import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4005";
const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

// Acciones asíncronas
export const fetchSeasonsByAnimeId = createAsyncThunk(
  'seasons/fetchByAnimeId', 
  async (animeId, thunkAPI) => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/seasons/content/anime/${animeId}`);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchSeasonsBySeriesId = createAsyncThunk(
  'seasons/fetchBySeriesId', 
  async (seriesId, thunkAPI) => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/seasons/content/series/${seriesId}`);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const addSeason = createAsyncThunk(
  'seasons/addSeason', 
  async ({ animeId, seriesId, seasonData }, thunkAPI) => {
    try {
      const authHeader = getAuthHeader();
      
      // Determinar el tipo de contenido basado en qué ID se proporciona
      let contentType, contentId;
      
      if (animeId) {
        contentType = 'anime';
        contentId = animeId;
      } else if (seriesId) {
        contentType = 'series';
        contentId = seriesId;
      } else {
        return thunkAPI.rejectWithValue({ 
          message: 'Se requiere animeId o seriesId para crear una temporada'
        });
      }
      
      // Construir el objeto de temporada con el tipo y ID de contenido correctos
      const seasonWithContent = {
        ...seasonData,
        contentType,
        contentId
      };
      
      console.log(`📝 [seasonSlice] Creando temporada para ${contentType} ID ${contentId}:`, seasonWithContent);
      const response = await axios.post(`${API_URL}/api/v1/seasons`, seasonWithContent, authHeader);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateSeason = createAsyncThunk(
  'seasons/updateSeason', 
  async ({ id, seasonData }, thunkAPI) => {
    try {
      const authHeader = getAuthHeader();
      const response = await axios.put(`${API_URL}/api/v1/seasons/${id}`, seasonData, authHeader);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteSeason = createAsyncThunk(
  'seasons/deleteSeason', 
  async (id, thunkAPI) => {
    try {
      const authHeader = getAuthHeader();
      await axios.delete(`${API_URL}/api/v1/seasons/${id}`, authHeader);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Slice
const seasonSlice = createSlice({
  name: 'seasons',
  initialState: {
    items: [],
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Manejar fetchSeasonsByAnimeId
      .addCase(fetchSeasonsByAnimeId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSeasonsByAnimeId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchSeasonsByAnimeId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Manejar fetchSeasonsBySeriesId
      .addCase(fetchSeasonsBySeriesId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSeasonsBySeriesId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchSeasonsBySeriesId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Manejar addSeason
      .addCase(addSeason.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      // Manejar updateSeason
      .addCase(updateSeason.fulfilled, (state, action) => {
        const index = state.items.findIndex(season => season.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      // Manejar deleteSeason
      .addCase(deleteSeason.fulfilled, (state, action) => {
        state.items = state.items.filter(season => season.id !== action.payload);
      });
  }
});

export default seasonSlice.reducer;
